<script setup lang="ts">
import PlaceHolder from '@/components/PlaceHolder/PlaceHolder.vue';
</script>

<template>
  <div :class="$style.placeHolderWrapper">
    <div :class="$style.resultCountHolderWrapper">
      <PlaceHolder />
    </div>
    <div :class="$style.dropdownPlaceHolderWrapper">
      <PlaceHolder />
    </div>
  </div>
</template>

<style module lang="scss">
@use '@/assets/variables' as *;

.placeHolderWrapper {
  display: flex;
  flex-wrap: wrap;
  gap: $space-50;
  justify-content: space-between;
  margin-bottom: $space-150;
}

.resultCountHolderWrapper {
  width: calc(2 * $space-700);
  height: $space-300;
}

.dropdownPlaceHolderWrapper {
  width: calc(2 * $space-900);
  height: $space-300;
}
</style>
